import { Layer, Toggle } from "@carbon/react";
import { FC, useEffect, useState } from "react";

import { TableToolbarFilter } from "src/components/Tables/TableToolbarFilter.tsx";
import { useT } from "src/internationalization";

export type BlacklistsFilterProps = {
  onApplyFilter: (values: FilterState) => void;
  onResetFilter: () => void;
  values: FilterState;
};

type FilterState = {
  includeDisabledElements: boolean;
};

export const BlacklistsFilter: FC<BlacklistsFilterProps> = ({
  onApplyFilter,
  onResetFilter,
  values,
}) => {
  const [includeDisabledElements, setIncludeDisabledElements] = useState(
    values.includeDisabledElements
  );
  const t = useT();

  useEffect(() => {
    setIncludeDisabledElements(values.includeDisabledElements);
  }, [values]);

  return (
    <TableToolbarFilter
      onApplyFilter={() => onApplyFilter({ includeDisabledElements })}
      onResetFilter={onResetFilter}
      onPopoverClose={() => setIncludeDisabledElements(values.includeDisabledElements)}
      numberOfFiltersApplied={values.includeDisabledElements !== false ? 1 : 0}
    >
      <Layer level={2} className="w-[500px]">
        <Toggle
          size="sm"
          labelA={t("page.blacklists.table.filters.inactive.label")}
          labelB={t("page.blacklists.table.filters.inactive.label")}
          toggled={includeDisabledElements}
          id="includeDisabledElements"
          onToggle={setIncludeDisabledElements}
        />
      </Layer>
    </TableToolbarFilter>
  );
};
